import styled, { css, keyframes } from 'styled-components'

import LoginLink from '../../LoginLink'
import LogoutLink from '../../LogoutLink'
import RegistrationLink from '../../RegistrationLink'
import MenuEntryLink from '../MenuEntryLink'

export const fadeInKeyframes = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const NavMenuContainer = styled.div<{ $isAnimated: boolean }>`
  ${({ $isAnimated }) =>
    $isAnimated &&
    css`
      animation: 0.5s ease 0s 1 ${fadeInKeyframes};
    `};
  width: 100%;
  max-width: 970px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  @media (min-width: 1200px) {
    max-width: 1200px;
  }
`

export const NavMenu = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  line-height: 1;
  margin: 0;
  top: 0;
  list-style: none;
  padding-left: 0;
  outline: 0 solid red;
`

export const NavMenuItem = styled.li`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 14px;
  &:not(:last-child) {
    margin: 0 1em;
  }
  &:last-child {
    margin-left: 1em;
  }

  ${MenuEntryLink}, ${LoginLink}, ${RegistrationLink}, ${LogoutLink} {
    color: ${({ theme }) => theme.colors.grayscale.white};
    text-transform: uppercase;
    text-decoration: none;
    transition: color 0.15s;
    &:active {
      outline: 1px solid #fff;
      outline-offset: 5px;
      color: ${({ theme }) => theme.colors.grayscale.white};
    }
    &:focus {
      outline: 1px solid #fff;
      outline-offset: 5px;
    }
    &:hover {
      color: ${({ theme }) => theme.colors.brand.red};
      text-decoration: underline;
    }
  }

  @media (min-width: 1200px) {
    font-size: 15px;
  }
`
